import React, { Component } from "react";
import { connect } from "react-redux";
import Helping from '../../helpers/Helping';
import Notification from '../layout/Notification';
import { create, update } from "../../services/lookupMain.service";
import { setErrorFields, validateField } from "../../helpers/validationHelpers";
import { fetchLookupParents } from "../../actions/lookup_parents_action";
import { LOOKUPS, GET_LOOKUP } from '../../config/routes';
import { MESSAGE } from '../../config/index';
import { setProfileError } from '../../actions/profile_action';
import LoadingButton from "../fields/LoadingButton";
import { API_URL } from '../../config/urls';
import Service from '../../helpers/service';
import $ from 'jquery'

const { EMPTY, CREATE, UPDATE, SELECT } = MESSAGE;
class Create extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageTitle: 'Add New Lookup',
            buttonTitle: 'Save',
            name: '',
            code: '',
            value: '',
            parent_id: '',
            description: '',
            content: [],
            url: API_URL.ADMIN_TRADING_API + LOOKUPS,
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsDisable: false
        };
    }

    handleChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "name") this.setState({ ...await validateField("string", name, value, "") });
        if (name === "code") this.setState({ ...await validateField("string", name, value, "", 1) });
        if (name === "value") this.setState({ ...await validateField("string", name, value, "") });
        if (name === "parent_id") this.setState({ ...await validateField("numeric", name, value, "", "", "parent") });
        if (name === "description") this.setState({ ...await validateField("string", name, value,) });
    }

    resetForm = () => {
        this.setState({
            name: '',
            code: '',
            value: '',
            parent_id: '',
            description: '',
            content: [],
            url: '',
            isLoading: true,
            btnIsDisable: false,
            error_name_message: '',
            error_code_message: '',
            error_parent_id_message: '',
            error_value_message: '',
            error_key_message: '',
            error_description_message: ''
        });
    }

    setErrorOnApiCall = () => {
        setProfileError((res) =>
            this.setState({ ...res })
        );
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    scrollToTop = () => {
        $('.addButton-slide').animate({ scrollTop: 0 }, 'slow');
    }

    componentDidMount() {
        let that = this;
        this.setErrorOnApiCall();

        if (!this.props.id) {
            this.setState({
                isLoading: false
            });
        }

        if (this.props.parents.length < 1) {
            this.props.fetchLookupParents();
        }

        if (this.props.id) {
            let id = this.props.id;

            that.setState({
                pageTitle: 'Edit Lookup',
                buttonTitle: 'Update'
            },
                () => that.getById(id));
        }

        $(".close-slide").click(function () {
            that.resetForm();
            that.removeNetworkError();
            that.setState({
                pageTitle: 'Add New Lookup',
                buttonTitle: 'Save'
            })
            that.props.closeEditModal();
        });
    }

    getById(id) {
        var self = this;

        Service.postCall(API_URL.ADMIN_TRADING_API + LOOKUPS, {
            "action": "by-id",
            id
        }).then(response => {
            console.log(response.data);
            let lookup = response.data.payload.lookUp;
            let content = [], parsedContent = JSON.parse(lookup.content);

            for (var key in parsedContent) {
                if (parsedContent.hasOwnProperty(key)) {
                    content.push({
                        key,
                        value: parsedContent[key]
                    });
                }
            }
            self.setState({
                name: lookup.name,
                code: lookup.code,
                value: lookup.value,
                parent_id: lookup.parentId === null ? 0 : lookup.parentId,
                description: lookup.description,
                content: content,
                isLoading: false
            });
        }).catch(error => {
            console.log({ error });

            if (error.response) {
                Helping.redirectToLogin(error);
                return self.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    isLoading: false
                });
            }
            return this.setState({
                isLoading: false,
                ...Helping.setNetworkRequestError(error, "fetching lookup")
            })
        });
    }

    checkEmptyInputFields = () => {
        let formHasError = false;

        if (this.state.name === "") {
            this.setState({ ...setErrorFields('name', Helping.getMessageString(EMPTY, "Name")) });
            formHasError = true;
        }
        if (this.state.code === "") {
            this.setState({ ...setErrorFields('code', Helping.getMessageString(EMPTY, "Code")) });
            formHasError = true;
        }

        if (this.state.parent_id.length < 1) {
            this.setState({ ...setErrorFields('parent_id', Helping.getMessageString(SELECT, "Parent")) });
            formHasError = true;
        }
        return formHasError;
    }

    onSave = (e) => {
        e.preventDefault();

        let formHasError = this.checkEmptyInputFields();
        if (formHasError) return;

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let content = {}, stateContent = this.state.content;
        for (let index = 0; index < stateContent.length; index++) {
            let currentContentKey = stateContent[index]['key'],
                currentContentValue = stateContent[index]['value'],
                content = {
                    ...content,
                    [currentContentKey]: currentContentValue
                };
        }

        let data = {
            "action": "create",
            name: this.state.name,
            code: this.state.code,
            value: this.state.value,
            parentId: this.state.parent_id,
            description: this.state.description,
            content: JSON.stringify(content)
        };

        Service.postCall(API_URL.ADMIN_TRADING_API + LOOKUPS, data).then(response => {
            this.props.create(response.data.payload.lookup);
            this.setState(
                {
                    error_message: Helping.getMessageString(CREATE, "Lookup"),
                    error_type: "success",
                    btnIsDisable: false
                }, () => { this.scrollToTop(); this.resetForm() }
            );
        }).catch(error => {
            if (error.response) {
                Helping.redirectToLogin(error);
                return this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => { this.scrollToTop(); });
            }
            return this.setState({
                isLoading: false,
                btnIsDisable: false,
                ...Helping.setNetworkRequestError(error, "creating lookup")
            }, () => { this.scrollToTop(); })
        });
    }

    onUpdate = (e) => {
        e.preventDefault();

        let formHasError = this.checkEmptyInputFields();
        if (formHasError) return;

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let content = {}, stateContent = this.state.content;
        for (let index = 0; index < stateContent.length; index++) {
            content = {
                ...content,
                [stateContent[index]['key']]: stateContent[index]['value']
            };
        }

        let data = {
            "action": "update",
            id: this.props.id,
            name: this.state.name,
            code: this.state.code,
            value: this.state.value,
            parentId: this.state.parent_id,
            description: this.state.description,
            content: JSON.stringify(content)
        };

        Service.postCall(API_URL.ADMIN_TRADING_API + LOOKUPS, data).then(response => {
            this.props.update(response.data.payload.lookup);
            this.setState(
                {
                    error_message: Helping.getMessageString(UPDATE, "Lookup"),
                    error_type: "success",
                    btnIsDisable: false
                }, () => () => { this.scrollToTop(); this.resetForm() }
            );

        }).catch(error => {
            if (error.response) {
                Helping.redirectToLogin(error);
                return this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => { this.scrollToTop(); });
            }
            return this.setState({
                isLoading: false,
                btnIsDisable: false,
                ...Helping.setNetworkRequestError(error, "updating lookup")
            }, () => { this.scrollToTop(); })
        });
    }

    handleArrayValueChange = (target, index) => {
        this.setState((previousState) => {
            let currentContent = previousState.content[index];
            currentContent[target.name] = target.value;
            return previousState
        })
    }

    handleArrayRemove = (e, index) => {
        e.preventDefault();

        const result = Helping.removeArrayFromIndex(this.state.content, index);
        this.setState({ content: result })
    }

    handleAddElementInArray = (e) => {
        e.preventDefault();

        this.setState((previousState) => {
            return previousState.content.push({ key: "", value: "" });
        })
    }

    render() {
        const { parents } = this.props;

        return (
            <div class="addButton-slide right-slider add-lookup">
                <div class="slide-top">
                    <div class="slide-header">
                        <h4 class="title">{this.state.pageTitle}</h4>
                        <span class="caption">Add information about a Lookup.</span>
                    </div>
                </div>

                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }

                <form class="info">
                    <div class="form-group">
                        <label for="lookupName">Lookup Name</label>
                        <input type="text" name="name" class={`form-control ${this.state.error_name_message ? 'error-input' : ''}`} value={this.state.name} id="lookupName" onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_name_message}</span>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="lookupCode">Code</label>
                                <input type="text" name="code" class={`form-control ${this.state.error_code_message ? 'error-input' : ''}`} value={this.state.code} id="lookupCode" onChange={(e) => this.handleChange(e)} />
                                <span className="error-msg">{this.state.error_code_message}</span>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="lookupVal">Value</label>
                                <input type="text" name="value" class={`form-control ${this.state.error_value_message ? 'error-input' : ''}`} value={this.state.value} id="lookupVal" onChange={(e) => this.handleChange(e)} />
                                <span className="error-msg">{this.state.error_value_message}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="lookupParent">Parent</label> <br />

                        <select class={`form-select ${this.state.error_parent_id_message ? 'error-input' : ''}`} name="parent_id"
                            aria-label="Parent select" id="lookupParent" value={this.state.parent_id}
                            onChange={(e) => this.handleChange(e)}
                        >
                            <option value="0" selected>Select Parent...</option>
                            {parents && parents.map((parent, i) =>
                                <option key={i} value={parent.id}>{parent.name}</option>
                            )}
                        </select>
                        <span className="error-msg">{this.state.error_parent_id_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="lookupDetail">Description</label>
                        <textarea class={`form-control ${this.state.error_description_message ? 'error-input' : ''}`} name="description" id="lookupDetail" value={this.state.description} rows="3" onChange={(e) => this.handleChange(e)}></textarea>
                        <span className="error-msg">{this.state.error_description_message}</span>
                    </div>
                    <div class="advanceOptions">
                        <label for="">Advance Attachments</label>
                        <button class="add-form" id="add" onClick={(e) => this.handleAddElementInArray(e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                        </button>
                    </div>

                    {this.state.content && this.state.content.map((row, i) => (
                        <div class="lookupAdvanceOption">
                            <div class="w-100 text-right">
                                <button class="close-form" id="delete" onClick={(e) => this.handleArrayRemove(e, i)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                </button>
                            </div>

                            <div id="textAreaFields">
                                <div class="form-group">
                                    <label for="lookupKey">Key</label>
                                    <input type="text" name="key" class={`form-control ${this.state.error_key_message ? 'error-input' : ''}`} id="lookupKey" value={row.key} onChange={(e) => this.handleArrayValueChange(e.target, i)} />
                                    <span className="error-msg">{this.state.error_key_message}</span>
                                </div>
                                <div class="form-group">
                                    <label for="lookupText">Text</label>
                                    <textarea class="form-control" name="value" id="lookupText" value={row.value} rows="2" onChange={(e) => this.handleArrayValueChange(e.target, i)}></textarea>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div class="slide-btn">
                        <div className="float-left">
                            <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                        </div>

                        <div class="float-right">
                            {!this.props.id &&
                                <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>
                            }

                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                this.props.id ? (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onUpdate(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                ) : (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                )}
                        </div>
                    </div>
                </form >
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile,
        lookUps: state.lookupMain,
        parents: state.parents,
        total: state.fetchLookupMainMeta.total,
        isLoading: state.fetchLookupMainMeta.isLoading
    };
};

const mapDispatchToProps = {
    create,
    update,
    fetchLookupParents
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Create);